import React from 'react';
import { useNavigate } from 'react-router-dom';
import './UpgradeModal.css';

/**
 * UpgradeModal Component
 *
 * A non-dismissible full-screen modal that appears when users try to access
 * features they don't have access to. Encourages them to schedule a call
 * with the founder for feedback and exclusive access.
 *
 * @param {string} featureName - Display name of the feature (e.g., "Dashboard Builder")
 */
function UpgradeModal({ featureName }) {
  const navigate = useNavigate();
  const calendlyUrl = 'https://calendly.com/daniel-foobalabs/30min';

  const handleGoBack = () => {
    navigate('/watchlist');
  };

  return (
    <div className="upgrade-modal-overlay">
      <div className="upgrade-modal-card">
        <div className="upgrade-modal-icon">
          <span role="img" aria-label="under construction">🚧</span>
        </div>

        <h2 className="upgrade-modal-title">Under Construction</h2>

        <p className="upgrade-modal-founder-intro">
          Hey, I'm the founder Daniel
        </p>

        <div className="upgrade-modal-feature">
          <span className="upgrade-modal-feature-name">{featureName}</span>
          <span className="upgrade-modal-coming-soon">is coming soon!</span>
        </div>

        <div className="upgrade-modal-message">
          <p>
            Schedule a 30 minute call with me to give feedback on the
            product and I'll give you exclusive access to more features.
          </p>
          <p className="upgrade-modal-message-secondary">
            I'd love to hear your input on how we can improve!
          </p>
        </div>

        <div className="upgrade-modal-buttons">
          <a
            href={calendlyUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="upgrade-modal-button"
          >
            Schedule a 30 Min Call
          </a>

          <button
            onClick={handleGoBack}
            className="upgrade-modal-button-secondary"
          >
            Go back to Watchlist
          </button>
        </div>
      </div>
    </div>
  );
}

export default UpgradeModal;
